import type { PalletLabelData } from 'types/assembly/model'

const generateProductLine = (productsZone: string, isStockOut: boolean) => {
  if (isStockOut) {
    return `
      ^FO383,18^GFA,378,378,7,,::::::K0JFC,J01JFE,J03KF,J07KF8,J0LFC,I01LFE,I03MF,I07MF8,I0NFC,001NFE,003OF,007OF8,00PF8,::::00MF1FF8,00FFC003E0FF8,00FFC001E07F8,:00FFC003E0FF8,00MF1FF8,00PF8,::::007OF8,003OF,001NFE,I0NFC,I07MF8,I03MF,I01LFE,J0LFC,J07KF8,J03KF,J01JFE,K0JFC,,::::::^FS
      ^FO380,90^FR^FDSTOCK OUT^FS
    `
  }
  if (productsZone === 'bulk') {
    return `
      ^FO383,18^GFA,378,378,7,,::::::::I078001E,I0FE003F8,001FE007F8,001FF007FC,::001FE007F8,I0FE003F8,I078001E,K03CI0F,K07F001FC,K0FF003FC,K0FF803FE,::K0FF003FC,K07F001FC,K03CI0F,I078001E,I0FE003F8,001FE007F8,001FF007FC,::001FE007F8,I0FE003F8,I078001E,K03CI0F,K07F001FC,K0FF003FC,K0FF803FE,::K0FF003FC,K07F001FC,K03CI0F,,::::::::^FS
      ^FO380,90^FR^FDGranel^FS
    `
  }
  if (productsZone === 'cleaning') {
    return `
      ^FO383,18^GFA,378,378,7,,:::::::::::::::::0JF8,0JFE,0KF8J078,0KFE0030F8,0LF803FF8,0FI07FE03FF8,0FI01FF81FF8,0FJ07FE0FF8,0FJ01FF87F8,0FK07FCFF8,0FK01FCFF8,0FL07CFF8,:0NFCFF8,::0NF87F8,0MFE01F,,:::::::::::::::::^FS
      ^FO380,90^FR^FDLimpieza^FS
    `
  }

  return `^FO380,25^FR^FDGeneral^FS`
}

export const generatePalletLabel = (labelData: PalletLabelData) => {
  const {
    docNum,
    warehouse,
    palletNumber,
    totalPallets,
    productsZone,
    isStockOut = false,
    container,
    totalSKUs,
    printDate,
    userName
  } = labelData
  const productLine = generateProductLine(productsZone, isStockOut)

  return `
    ^XA
      ^FWR
      ^CI28
      ^CFA,60

      ^FO470,16^GB120,650,10^FS
      ^FO470,16^GB120,650,60,B^FS
      ^FO490,45^FR^FD${docNum}-${warehouse}^FS

      ^FO470,930^GB120,250,10^FS
      ^FO470,930^GB120,250,60,B^FS
      ^FO490,955^FR^FD${palletNumber}/${totalPallets}^FS

      ^CFA,50
      ${productLine}

      ^FO300,18^GFA,378,378,7,,:::0FF,0FF8,:::::00F81MF,00F83MF,00F87MF8,::00F87CK0F8,:::00F87CI0F0F8,00F87C001F0F8,::0FF87C001F0F8,:::::00F87C001F0F8,::00F87CI0F0F8,00F87CK0F8,:::00F87MF8,::00F83MF8,00F81MF,0FF8,:::::0FF,,:::^FS
      ^FO295,90^FR^FD${container}^FS

      ^CFA,45

      ^FO210,20^GFA,378,378,7,,:::I0JFE,003KF8,007LF,007LFC1F,00NF3F8,00F8I01JF8,00F8J07IF8,00F8K0IF8,00F8K03FF8,00F8L0FF8,00F8L03F8,::::00CM03F8,P0FF8,O07FF8,J0EI01IF8,I0FFE007IF8,003IF01JF8,007IFC0FF3F8,00JFE0781F,01FC0FF06,03F003F8,07E001F8,07CI0FC07,078I07C1FC,0F8I03C3FE,0F8I03E3FF,0FJ03E7FF,:0FJ03E6,0FJ03E78,0F8I03E7C,0F8I03C7C,078I07C7E,07CI0FC7E,07E001F87E,03F003F87C,01FC0FF07C,00JFE078,007IFC07,003IF8,I0FFE,J0C,,:::^FS
      ^FO210,90^FR^FD${totalSKUs}^FS

      ^FO120,18^GFA,378,378,7,,::::::03NFC,07NFE,0PF,:0F8J01F0F,0FK01E0F,0FK01E0FE,0FK01E0FF,0F001F81E0FF8,0F003FC1E0FF8,0F007FE1E0FF,0F00FFE1E0F,:0F00IF1E0F,0F00FFE1E0F,0F007FE1E0F,0F007FC1E0F,0F003F81E0F,0FI0F01E0F,0FK01E0F,:::::::::0FK01E0FF,0FK01E0FF8,:0FK01E0FF,0FK01E0FE,0FK01E0F,0F8J01F0F,0PF,:07NFE,03NFC,,::::::^FS
      ^FO118,90^FR^FD${printDate}^FS

      ^CFA,35

      ^FO30,18^GFA,378,378,7,,::::::::007F8,00FFC,00FFE,00IF,00IF8,00F8F8,00F87C,:00F83C,00F83E00FC,00F83E03FF,00F81E07FF8,00F81E0IFC,00F81F1IFE,00F81F1F83F,00F81F1F01F,00F81F3E00F,00F80F3E00F,:00F81F3E00F,00F81F1F01F,00F81F1F03F,00F81F1IFE,00F81F0IFC,00F81E07FF8,00F83E03FF,00F83E00FC,00F83C,00F87C,:00F8F8,00IF8,00IF,00FFE,00FFC,007F8,,::::::::^FS
      ^FO35,90^FR^FD${userName}^FS

      ^FO120,900
      ^BQN,2,10
      ^FDLA,${container}^FS
    ^XZ
  `
}
